<template>
  <b-container>
    <b-row>
      <h2>BI</h2>
      <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </b-row>
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="bi"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </b-row>
    {{ moduleId }}
  </b-container>
</template>
<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "ModuleBiList",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  props: {
    moduleId: String,
  },
  data() {
    return {
      alert: {
        error: "Bi não excluido",
        success: "Bi excluido",
      },
      isBusy: false,
      bi: [],
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "checklist-filled-table-col-buttons",
        },
        {
          key: "id",
          filterKey: "id",
          sortable: false,
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sidebarTitle",
          filterKey: "sidebarTitle",
          sortable: true,
          label: "BI",
        },
      ],
      tableFilters: [],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  created() {
    this.getAllBi();
  },
  methods: {
    getAllBi() {
      let apiParam = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
      };
      this.$apiScheduler
        .post("module/getAllBi/" + this.moduleId, apiParam)
        .then((response) => {
          console.log(response);
          this.bi = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          conosole.log(this.bi);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    deleteBi(id) {
      this.$apiScheduler.get("/powerbiview/delete/" + id, this.moduleId).then((response) => {
        this.alert.success = response.data.title;
        this.$refs.alert.show();
      });
    },
  },
};
</script>
